import { SearchOutlined } from "@ant-design/icons";
import { Button, Card, Input, Select, Space } from "antd";
import Search from "antd/es/input/Search";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BatchPaymentTable from "../../../components/NP/Payment/BatchPaymentTable";
import CreateBatchPaymentModal from "../../../components/NP/Payment/CreateBatchPaymentModal";
import Subheader from "../../../components/ui/Subheader";
import { ArrayOption, selectSearchOption } from "../../../helpers/siteConfig";
import useDebounce from "../../../hooks/useDebounce";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import AdminLayout from "../../../layouts/AdminLayout";
import {
  getAllAreaAsync,
  getAllRegionAsync,
  getAllTerritoryAsync,
} from "../../../store/features/NP/geoInfo/geoAPI";
import { getSinglePOForVendorAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CreditCardItem } from "../../../types/redux/NP/supplier";
import { stringToArray } from "../../../utils/array";
import { formatSouthAsianNumber } from "../../../utils/number";
import { toast } from "../../../helpers/toast";
import IconButton from "../../../components/common/IconButton";
import UploadIconV2 from "../../../assets/icons/UploadIconV2";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import useExcelDownload from "../../../hooks/useExcelDownload";

export default function BatchPayment() {
  const { login } = useAppSelector((state) => state.login);
  const { keyword, handleInputChange, handleEnterValue } = useDebounce();
  const { open, handleOpen, toggle } = useModal();
  const {
    open: openImportExcel,
    toggle: toggleImportExcel,
    handleOpen: handleOpenImportExcel,
  } = useModal();
  const { handleSetFirstPage, ...rest } = useTable();
  const dispatch = useAppDispatch();
  const { getSinglePOForVendor } = useAppSelector((state) => state.supplier);
  const location = useLocation();
  const path = stringToArray(location.pathname, "/")?.[0];
  const { regions, areas, territorys } = useAppSelector((state) => state.npGeo);
  const [regionId, setRegionId] = useState<string | undefined>(undefined);
  const [areaId, setAreaId] = useState(undefined);
  const [territoryId, setTerritoryId] = useState(undefined);
  const [trackingNumber, setTrackingNumber] = useState(undefined);
  const [poNumber, setPoNumber] = useState(undefined);
  const [statusFilter, setStatusFilter] = useState(undefined);
  const [downloadClicked, setDownloadClicked] = useState(false);

  const { excelLoading, downloadExcel, handleExcelLoading } = useExcelDownload(
    "Batch-payment-table-data"
  );

  const creditCards: CreditCardItem[] = [
    {
      title: "Total Monthly Credits",
      value: `৳${
        getSinglePOForVendor?.carryForwardBalance
          ? formatSouthAsianNumber(
              getSinglePOForVendor?.initialMoney +
                getSinglePOForVendor?.carryForwardBalance
            )
          : "0"
      }`,
    },
    {
      title: "Remaining Credits",
      value: `৳${
        getSinglePOForVendor?.remainingPoBalance
          ? formatSouthAsianNumber(getSinglePOForVendor?.remainingPoBalance)
          : "0"
      }`,
    },
    {
      title: "Use Credits",
      value: `${
        getSinglePOForVendor?.calculatedUsagePercentage
          ? formatSouthAsianNumber(
              getSinglePOForVendor?.calculatedUsagePercentage
            )
          : "0"
      }%`,
    },
  ];

  useEffect(() => {
    if (login?.role === "vendor") {
      dispatch(getSinglePOForVendorAsync());
    }
  }, [dispatch, login?.role]);

  useEffect(() => {
    dispatch(getAllRegionAsync({}));
  }, [dispatch]);

  useEffect(() => {
    if (regionId)
      dispatch(
        getAllAreaAsync({
          params: {
            region: regionId,
          },
        })
      );
  }, [dispatch, regionId]);

  useEffect(() => {
    if (areaId)
      dispatch(
        getAllTerritoryAsync({
          params: {
            area: areaId,
          },
        })
      );
  }, [dispatch, areaId]);

  useEffect(() => {
    if (
      login?.role === "vendor" ||
      login?.role === "region" ||
      login?.role === "cluster" ||
      login?.role === "energyOps" ||
      login?.role === "directorOps" ||
      login?.role === "gr" ||
      login?.role === "finance"
    ) {
      setRegionId(login?.region);
    }
  }, [login?.region, login?.role]);

  return (
    <>
      {open?.type === "BATCH_PAYMENT" && (
        <CreateBatchPaymentModal
          open={open?.open}
          handleClose={toggle}
          data={{ cluster: regionId, zone: areaId }}
        />
      )}

      <AdminLayout title="Payment Summary" headerTitle="Payment">
        {login?.role === "vendor" && (
          <section className="mt-7">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {creditCards.map((card, index) => (
                <Card className="shadow border-none bg-[#F0F3F9]" key={index}>
                  <div className="justify-start text-body text-base font-medium">
                    {card.title}
                  </div>
                  <div className="justify-start text-body text-3xl font-semibold">
                    {card.value}
                  </div>
                </Card>
              ))}
            </div>
          </section>
        )}

        <section className="mt-7">
          <Subheader title="Payment Summary" subTitle={``}>
            <Space size="small" wrap>
              {login?.role === "vendor" && (
                <>
                  {/* <Select
                    placeholder="Status"
                    allowClear
                    showSearch
                    // filterOption={selectSearchOption}
                    // options={ArrayOption(allSupplier, "supplierName", "_id")}
                    // onChange={(val) => {
                    //   setSupplierId(val);
                    // }}
                    // value={supplierId}
                    // disabled={!areaId}
                    className="min-w-[120px]"
                    optionFilterProp="children"
                  /> */}
                </>
              )}

              {/* <Select
                placeholder="Today"
                allowClear
                showSearch
                // filterOption={selectSearchOption}
                // options={ArrayOption(allSupplier, "supplierName", "_id")}
                // onChange={(val) => {
                //   setSupplierId(val);
                // }}
                // value={supplierId}
                // disabled={!areaId}
                className="min-w-[120px]"
                optionFilterProp="children"
              /> */}

              {/* {path === "finance" && (
                <h6 className="text-header text-base font-medium mr-6">
                  Balance: ৳ 65,56,524
                </h6>
              )} */}

              <Search
                placeholder="Search by batch name"
                onSearch={(val) => {
                  handleEnterValue(val);
                  handleSetFirstPage(true);
                }}
                onChange={(val) => {
                  handleInputChange(val);
                  handleSetFirstPage(true);
                }}
                className="custom-search-input max-w-[200px]"
              />
              <Select
                value={regionId}
                placeholder="Cluster"
                allowClear
                showSearch
                filterOption={selectSearchOption}
                options={ArrayOption(regions, "regionName", "_id", true)}
                onChange={(val) => {
                  setRegionId(val);
                  setAreaId(undefined);
                  setTerritoryId(undefined);
                }}
                className="min-w-[80px]"
                disabled={
                  login?.role === "region" ||
                  // login?.role === "finance" ||
                  login?.role === "vendor"
                }
                popupMatchSelectWidth={120}
              />
              <Select
                placeholder="Zone"
                allowClear
                showSearch
                filterOption={selectSearchOption}
                options={ArrayOption(areas, "areaName", "_id", true)}
                onChange={(val) => {
                  setAreaId(val);
                  setTerritoryId(undefined);
                }}
                value={areaId}
                disabled={!regionId}
                className="min-w-[80px]"
                popupMatchSelectWidth={120}
              />
              {/* <Select
                placeholder="Maintenance"
                allowClear
                showSearch
                filterOption={selectSearchOption}
                options={ArrayOption(territorys, "teritoryName", "_id", true)}
                onChange={(val) => {
                  setTerritoryId(val);
                }}
                value={territoryId}
                disabled={!areaId}
                className="min-w-[80px]"
                optionFilterProp="children"
                popupMatchSelectWidth={120}
              /> */}
              <Select
                placeholder="Status"
                allowClear
                showSearch
                filterOption={selectSearchOption}
                options={[
                  { label: "Passed", value: "passed" },
                  { label: "Pending", value: "pending" },
                  { label: "Processing", value: "processing" },
                  { label: "Paid", value: "paid" },
                  { label: "Failed", value: "failed" },
                  { label: "Rejected", value: "rejected" },
                  { label: "Draft", value: "draft" },
                ]}
                onChange={(val) => {
                  setStatusFilter(val);
                }}
                className="min-w-[80px]"
                optionFilterProp="children"
                popupMatchSelectWidth={120}
              />

              {/* {login?.role === "vendor" && (
                <Button
                  type="primary"
                  onClick={() => {
                    if (!areaId) {
                      toast("warning", "Please select zone");
                      return;
                    }
                    handleOpen({
                      type: "BATCH_PAYMENT",
                    });
                  }}
                >
                  Create Batch Payment
                </Button>
              )} */}

              {login?.role === "finance" && (
                <>
                  <IconButton
                    className="!bg-[#FC8415] !hover:bg-[#FC8415] !text-white !border-[#FC8415]"
                    onClick={() =>
                      handleOpenImportExcel({
                        type: "IMPORT_EXCEL",
                      })
                    }
                  >
                    <div className="flex items-center gap-x-2">
                      <UploadIconV2 />
                      <span>Import</span>
                    </div>
                  </IconButton>

                  {/* <Button
                    loading={excelLoading}
                    className="btn-status !bg-status-info-btn"
                    icon={<DownloadIcon />}
                    onClick={() => setDownloadClicked(true)}
                  >
                    Export
                  </Button> */}
                </>
              )}
            </Space>
          </Subheader>

          {path === "finance" && (
            <Space className="mt-5" wrap size={16}>
              <Input
                size="large"
                placeholder="Tracking number"
                className="shadow-md shadow-gray-200"
                onChange={(e: any) => setTrackingNumber(e.target.value)}
                suffix={
                  <span className="text-others-gray">
                    <SearchOutlined />
                  </span>
                }
                allowClear
              />
              <Input
                size="large"
                placeholder="PO number"
                className="shadow-md shadow-gray-200"
                onChange={(e: any) => setPoNumber(e.target.value)}
                suffix={
                  <span className="text-others-gray">
                    <SearchOutlined />
                  </span>
                }
                allowClear
              />
            </Space>
          )}

          <BatchPaymentTable
            keyword={keyword}
            handleSetFirstPage={handleSetFirstPage}
            downloadExcel={downloadExcel}
            handleExcelLoading={handleExcelLoading}
            downloadClicked={downloadClicked}
            setDownloadClicked={setDownloadClicked}
            openImportExcel={openImportExcel}
            toggleImportExcel={toggleImportExcel}
            filter={{
              regionId,
              areaId,
              territoryId,
              trackingNumber,
              poNumber,
              statusFilter,
            }}
            {...rest}
          />
        </section>
      </AdminLayout>
    </>
  );
}
